import { SELF_SERVE_PLANS } from "../pricing";
import { PlanCard } from "../components/PlanCard";

export function Pricing() {
  return (
    <section className="section section-plans">
      <div className="container">
        <div className="pricing-head">
          <div className="eyebrow">Membership</div>
          <h1 className="h-display h2">Plans that <em>fit your life.</em></h1>
          <p>
            One simple membership, billed monthly. Cancel or pause anytime — no claims, no surprises.
            Every plan includes the full 250-MD network.
          </p>
        </div>
        <div className="plans-grid">
          {SELF_SERVE_PLANS.map((plan) => (
            <PlanCard key={plan.tier} plan={plan} />
          ))}
        </div>
        <p className="pricing-note">
          Fighter membership is reserved for sponsored and professional athletes by invitation.
        </p>
      </div>
    </section>
  );
}
